// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const exeggcute: PokeData = {
  "id": 102,
  "name": "exeggcute",
  "height": 4,
  "weight": 25,
  "base_experience": 65,
  "types": [
    PokeType.GRASS,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "psybeam",
    "absorb",
    "mega-drain",
    "leech-seed",
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "sleep-powder",
    "confusion",
    "psychic",
    "hypnosis",
    "reflect",
    "barrage",
    "giga-drain",
    "synthesis",
    "uproar",
    "extrasensory",
    "bullet-seed",
    "natural-gift",
    "worry-seed",
    "bestow"
  ],
  "moves": [
    "solar-beam",
    "poison-powder",
    "stun-spore",
    "psychic",
    "reflect",
    "synthesis",
    "bullet-seed",
    "branch-poke",
    "aromatherapy",
    "psy-pulse",
    "psychic-fangs",
    "leaf-tornado",
    "future-sight"
  ],
  "evolution_chain": {
    "id": 45,
    "item": null,
    "species": [
      {
        "name": "exeggcute",
        "order": 111,
        "types": [
          PokeType.GRASS,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "exeggutor",
        "order": 112,
        "types": [
          PokeType.GRASS,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 102,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "exeggutor-alola",
        "order": 112,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 102,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "leaf-stone"
            },
            "location": {
              "name": "alola"
            },
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61.25,
    "speed": 40,
    "ability_power": 60
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
